import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { Item, ItemAvatar, ItemContent, ItemTitle, TableCell, TableRow, tableRowSizeVariants, useTable } from "@opensea/ui-kit";
import { readFragment } from "gql.tada";
import { TRANSFER_FLOW_FORM_ITEM_CLASSNAMES } from "../TransferFlowFormItem/constants";
import { TransferFlowReviewItemFragment } from "./TransferFlowReviewItem.fragment";
export const TransferFlowReviewItem = t0 => {
  const $ = _c(33);
  const {
    item: itemKey
  } = t0;
  let t1;
  if ($[0] !== itemKey) {
    t1 = readFragment(TransferFlowReviewItemFragment, itemKey);
    $[0] = itemKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const item = t1;
  const {
    size
  } = useTable();
  let T0;
  let T1;
  let T2;
  let T3;
  let t2;
  let t3;
  let t4;
  if ($[2] !== size) {
    const {
      image
    } = tableRowSizeVariants({
      size
    });
    T3 = TableRow;
    T2 = TableCell;
    t4 = TRANSFER_FLOW_FORM_ITEM_CLASSNAMES.item;
    T1 = Item;
    t3 = "unstyled";
    T0 = ItemAvatar;
    t2 = image();
    $[2] = size;
    $[3] = T0;
    $[4] = T1;
    $[5] = T2;
    $[6] = T3;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    T0 = $[3];
    T1 = $[4];
    T2 = $[5];
    T3 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== T0 || $[11] !== item.imageUrl || $[12] !== t2) {
    t5 = <T0 className={t2} src={item.imageUrl} />;
    $[10] = T0;
    $[11] = item.imageUrl;
    $[12] = t2;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== item.name) {
    t6 = <ItemTitle>{item.name}</ItemTitle>;
    $[14] = item.name;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== item.collection) {
    t7 = item.collection ? <CollectionLockup collection={item.collection} size="xs"><CollectionLockupContent><CollectionLockupTitle /></CollectionLockupContent></CollectionLockup> : null;
    $[16] = item.collection;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <ItemContent>{t6}{t7}</ItemContent>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== T1 || $[22] !== t3 || $[23] !== t5 || $[24] !== t8) {
    t9 = <T1 variant={t3}>{t5}{t8}</T1>;
    $[21] = T1;
    $[22] = t3;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== T2 || $[27] !== t4 || $[28] !== t9) {
    t10 = <T2 className={t4}>{t9}</T2>;
    $[26] = T2;
    $[27] = t4;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== T3 || $[31] !== t10) {
    t11 = <T3>{t10}</T3>;
    $[30] = T3;
    $[31] = t10;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};